export const formatDisplayValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "number") return String(value);
  if (typeof value === "string") return value;
  return JSON.stringify(value);
};

export const buildDisplayFromSearchData = (product, searchData) => {
  if (!searchData || typeof searchData !== "object") {
    return "-";
  }

  const normalizedProduct = String(product || "").toLowerCase();
  const lines = [];

  if (normalizedProduct === "flights") {
    if (searchData.origin && searchData.destination) {
      lines.push(`${searchData.origin} → ${searchData.destination}`);
    } else if (searchData.from && searchData.to) {
      lines.push(`${searchData.from} → ${searchData.to}`);
    }
    if (searchData.departureDate) lines.push(searchData.departureDate);
    if (searchData.passengers) lines.push(`${searchData.passengers} passenger(s)`);
    if (searchData.cabinClass) lines.push(searchData.cabinClass);
    if (searchData.tripType) lines.push(searchData.tripType);
  } else if (normalizedProduct === "hotels") {
    if (searchData.city || searchData.destination) {
      lines.push(searchData.city || searchData.destination);
    }
    if (searchData.checkIn || searchData.fromDate) {
      lines.push(`${searchData.checkIn || searchData.fromDate} - ${searchData.checkOut || searchData.toDate || ""}`.trim());
    }
    if (searchData.guests) lines.push(`${searchData.guests} guest(s)`);
    if (searchData.rooms) lines.push(`${searchData.rooms} room(s)`);
  } else if (normalizedProduct === "insurance") {
    if (searchData.product) lines.push(searchData.product);
    if (searchData.coverage) lines.push(searchData.coverage);
    if (searchData.destination) lines.push(searchData.destination);
    if (searchData.tripType) lines.push(searchData.tripType);
  } else if (normalizedProduct === "events") {
    if (searchData.city || searchData.location) lines.push(searchData.city || searchData.location);
    if (searchData.eventName) lines.push(searchData.eventName);
    if (searchData.date) lines.push(searchData.date);
  } else if (normalizedProduct === "packages") {
    if (searchData.destination) lines.push(searchData.destination);
    if (searchData.packageName) lines.push(searchData.packageName);
    if (searchData.travelDates) lines.push(searchData.travelDates);
  }

  if (lines.length === 0) {
    return Object.entries(searchData)
      .slice(0, 4)
      .map(([key, value]) => `${key}: ${formatDisplayValue(value)}`)
      .join(" | ");
  }

  return lines.join(" | ");
};

export const formatSearchText = (record) => {
  if (!record) return "-";
  if (record.searchText) return record.searchText;
  if (record.search) return record.search;
  if (record.criteria) return record.criteria;
  if (record.searchData) return buildDisplayFromSearchData(record.product, record.searchData);
  return JSON.stringify(record) || "-";
};

export const getZeroResultBadge = (value) => {
  if (value === null || value === undefined) return "-";
  return Number(value) > 0 ? "Has zero results" : "No zero results";
};
